<template>
    <div>
        <v-card elevation="0">
            <v-card-text>
                <v-btn v-if="!editmode" icon outlined color="#478C5C" @click="editmode = true" style="float: right;"><v-icon>mdi-lock-open-plus</v-icon></v-btn>
                <v-row dense>
                    <v-col cols="8">
                        <v-simple-table style="border-collapse: collapse;" dense>
                            <template v-slot:default>
                                <tbody>
                                    <tr>
                                        <td>{{ user.cn }}</td>
                                        <td>{{ user.department }}</td>
                                        <td>{{ user.username }}</td>
                                        <td>{{ user.email }} </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row><br />
                <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                    <v-row dense>
                        <v-col cols="12" class="font-weight-bold" style="color: #05445E"><v-icon color="#05445E">mdi-shield-lock-outline</v-icon>&nbsp;Admin</v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.adminpermissionsmanage" label="Permissions Setting" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.setannouncement" label="Setting Announcement" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                    </v-row>
                </div><br />
                <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                    <v-row dense>
                        <v-col cols="12" class="font-weight-bold" style="color: #05445E"><v-icon color="#05445E">mdi-office-building-cog</v-icon>&nbsp;Academic Department Configuration</v-col>
                        <v-col cols="4">
                            <v-checkbox v-model="user.getacademicdepartments" label="View Departments and disciplines settings" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="4">
                            <v-checkbox v-model="user.setacademicdepartment" label="Create/Edit Department settings" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="4">
                            <v-checkbox v-model="user.deleteacademicdepartment" label="Delete Department settings" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                    </v-row>
                </div><br />
                <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                    <v-row dense>
                        <v-col cols="12" class="font-weight-bold" style="color: #05445E">
                            <v-icon color="#05445E">mdi-bank-outline</v-icon>&nbsp;Academic Department Access
                        </v-col>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="4" v-for="group in departmentlist" :key="group">
                                    <v-row>
                                        <v-col cols="12" v-for="discipline in group" :key="discipline">
                                            <v-checkbox v-model="user.allowedDepartments" :label="discipline" :value="discipline" hide-details dense :readonly="!editmode"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div><br />
                <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                    <v-row dense>
                        <v-col cols="12" class="font-weight-bold" style="color: #05445E"><v-icon color="#05445E">mdi-newspaper-variant-outline</v-icon>&nbsp;Posting</v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.postingwrite" label="Create/Edit Job Postings" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.postingapprove" label="Approve Job Postings" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.postingstop" label="Stop Job Postings" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.postingdelete" label="Delete Job Postings" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.timetableinterface" label="Upload Timetable/Manage Custom Timetable" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.postingliveedit" label="Edit Active Postings" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.offerlettergenerate" label="Generate Offer Letter" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.postingfill" label="Mark Posting Filled" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                    </v-row>
                </div><br />
                <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                    <v-row dense>
                        <v-col cols="12" class="font-weight-bold" style="color: #05445E"><v-icon color="#05445E">mdi-account-eye-outline</v-icon>&nbsp;Accounts/Applicants</v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.getaccountslist" label="View Account Manager" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.setADOflag" label="ADO Contact Flagging" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="6">
                            <v-checkbox v-model="user.setHRflag" label="View/Set HR Flag" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                    </v-row>
                </div><br />
                <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                    <v-row dense>
                        <v-col cols="12" class="font-weight-bold" style="color: #05445E"><v-icon color="#05445E">mdi-format-list-checks</v-icon>&nbsp;Application</v-col>
                        <v-col cols="6"><v-select v-model="user.searchrange" :items="searchrangeitems" label="Search Range" outlined dense :readonly="!editmode" hide-details></v-select></v-col>
                        <v-col cols="6"></v-col>
                        <v-col cols="4">
                            <v-checkbox v-model="user.adminformcontrol" label="Modify Form Configuration" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="4">
                            <v-checkbox v-model="user.justifications" label="Justification Comments" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="4">
                            <v-checkbox v-model="user.managercomments" label="Manager Comments" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="4">
                            <v-checkbox v-model="user.seniorityPoints" label="Modify Seniority Points" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="4">
                            <v-checkbox v-model="user.replaceCV" label="Replace Applicant Resume/CV" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="4">
                            <v-checkbox v-model="user.setemail" label="Edit Email Receipt" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                    </v-row>
                </div><br />
                <div style="border-style: solid; border-width: 1px; border-color: #05445E; padding: 5px;">
                    <v-row dense>
                        <v-col cols="12" class="font-weight-bold" style="color: #05445E"><v-icon color="#05445E">mdi-file-export-outline</v-icon>&nbsp;Export</v-col>
                        <v-col cols="4">
                            <v-checkbox v-model="user.exportdata" label="Export Applicant Data" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="4">
                            <v-checkbox v-model="user.exposeAll" label="Expose 'All' option for Disciplines" dense :readonly="!editmode" hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                        <v-col cols="4">
                            <v-checkbox v-model="user.exportAllowAnyCourse" label="Use 'Any' for Course" dense hide-details :true-value="1" :false-value="0"></v-checkbox>
                        </v-col>
                    </v-row>
                </div><br />
                <v-btn v-if="editmode" outlined color="#478C5C" @click="updatePermission" style="float: right;" :loading="updateloading">Update Permissions</v-btn>
            </v-card-text>
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
export default {
    props: {
        user: {
            required: true
        },
        departmentlist: {
            required: true
        }
    },
    data(){
        return{
            editmode: false,
            host: location.hostname.toString(),
            searchrangeitems: ['All','Current Calendar Year Only', 'Previous and Current Calendar Year'],
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500,
            updateloading: false
        }
    },
    methods: {
        updatePermission(){
            const that = this;
            that.updateloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py';

            const formData = new FormData();
            formData.append("mode", "setpermission");
            formData.append("data", JSON.stringify(that.user));

            fetch(api, {
                method: 'POST',
                body: formData
            })
            .then(function(response){
                return response.json();
            })
            .then(function (data) {
                if(data.result.match(/ok/i)){
                    that.setSnackbar("Successful: "+data.message.toString(), "green");
                    that.editmode = false;
                }else {
                    that.setSnackbar("Warning: "+data.message.toString(), "orange");
                }

                that.updateloading = false;
            })
            .catch(function (err) {
                that.setSnackbar("Error occurred : "+err.toString(), "red");
                that.updateloading = false;
            })
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        },
    },
}
</script>